import { SendOutlined } from "@ant-design/icons";
import { Button, Input, Select, Space } from "antd";
import React, { useState } from "react";

const { TextArea } = Input;

type CommentFormProps = {
  onSubmit?: (
    text: string,
    mentionedPersonIds: number[],
  ) => Promise<boolean | void> | boolean | void;
  mentionOptions?: Array<{ value: number; label: string }>;
  canMention?: boolean;
};

const CommentForm: React.FC<CommentFormProps> = ({
  onSubmit,
  mentionOptions = [],
  canMention = true,
}) => {
  const [text, setText] = useState("");
  const [mentionedPersonIds, setMentionedPersonIds] = useState<number[]>([]);
  const [mentionSearch, setMentionSearch] = useState("");

  const handleSubmit = async () => {
    if (text.trim()) {
      const result = await onSubmit?.(text, mentionedPersonIds);

      if (result !== false) {
        setText("");
        setMentionedPersonIds([]);
      }
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      handleSubmit();
    }
  };

  return (
    <div className="comment-form">
      <Space
        direction="vertical"
        size="middle"
        style={{ width: "100%" }}
      >
        <TextArea
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Написать комментарий..."
          autoSize={{ minRows: 3, maxRows: 8 }}
        />

        {canMention && (
          <Space.Compact style={{ width: "100%" }}>
            <Button
              disabled
              style={{ pointerEvents: "none" }}
            >
              @
            </Button>
            <Select
              mode="multiple"
              showSearch
              style={{ width: "100%" }}
              value={mentionedPersonIds}
              options={mentionOptions}
              onChange={(value) => setMentionedPersonIds(value as number[])}
              searchValue={mentionSearch}
              onSearch={(value) => setMentionSearch(value.replace(/@/g, ""))}
              optionFilterProp="label"
              placeholder="Упомянуть пользователей"
            />
          </Space.Compact>
        )}

        <Button
          type="primary"
          icon={<SendOutlined />}
          onClick={handleSubmit}
          disabled={!text.trim()}
        >
          Отправить
        </Button>
      </Space>
    </div>
  );
};

export default CommentForm;
